import { render, staticRenderFns } from "./MeasurementType.vue?vue&type=template&id=a71c4806&"
import script from "./MeasurementType.vue?vue&type=script&lang=ts&"
export * from "./MeasurementType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports